import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = () => ({
  bottom: 0,
  position: 'absolute',
  width: '100%',
});

const ProgressBar = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

ProgressBar.propTypes = {
  children: PropTypes.node,
};

export default React.memo(ProgressBar);
